<template>
    <div class="news">
        <appPopUp :popUp="show" :btnPrev="btnPrev" :btnNext="btnNext" :text="text" :title="title" :img="img" :id="id" :getAllId="getAllId" @closePopUp="closePopUp" @contentId="contentId" />
        <h2 class="titleBlock" v-html="pagetitle"></h2>
        <template>
            <swiper class="swiper" :options="swiperOption">
                <swiper-slide v-for="item in news" :key="item.id">
                    <div class="box" @click="showPopUp(item.id)">
                        <div class="box__img">
                            <img :src="item.preview_image">
                        </div>
                        <div class="box__content">
                            <p class="box__title" v-html="item.title"></p>
                            <p class="box__text" v-html="item.preview_text"></p>
                            <span class="box__date" v-html="item.date"></span>
                        </div>
                    </div>
                </swiper-slide>
            </swiper>
        </template>
        <div class="slider-button-line">
            <div class="slider-button-line__box">
                <button class="slider-button" id="slider-button-prev" slot="button-prev"><i class="far fa-angle-left"></i></button>
                <button class="slider-button" id="slider-button-next" slot="button-next"><i class="far fa-angle-right"></i></button>
            </div>
            <div class="slide-scrollBar">
                <div class="slide-drag"></div>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from 'axios'
    import VueAxios from 'vue-axios'
    import PopUp from '@/components/PopUp'
    import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
    import 'swiper/css/swiper.css'
    import { HTTP, Routes } from '../API'

    export default {
        name: 'swiper-example-free-mode',
        title: 'Free mode / No fixed positions',
        components: {
            Swiper,
            SwiperSlide,
            appPopUp: PopUp,
           
        },
        props:{
            langContent:{type: String, default: 'ru'},
        },
        data() {
            return {
                removeScrollButton: true,
                show: false,
                text:'',
                title:'',
                img:'',
                id: 0,
                blockScroll: false,
                swiperOption: {
                    loop: false,
                    slidesPerView: 3,
                    slidesPerColumn: 1,
                    spaceBetween: 20,
                    watchOverflow: true,
                    scrollbar: {
                        el: '.slide-scrollBar',
                        draggable: true,
                        dragSize: 'auto',
                        dragClass: 'slide-drag',
                        snapOnRelease: true
                    },
                    navigation: {
                        nextEl: '#slider-button-next',
                        prevEl: '#slider-button-prev'
                    },
                },
              
                allId:[],
                getAllId: null,
                pagetitle: null,
                news: [],
                nextButton: null,
                btnPrev: 'Предыдущая',
                btnNext: 'Следующая'
            }
        },
        methods:{
            // Закрыть popUp
            closePopUp(popUp){
                this.show = !popUp
                this.$router.push({ path: `/${this.langContent}/news` })
                this.blockScroll = true
                this.$emit('noScroll', this.blockScroll)
            },
            contentId(idContent){
                let index = idContent
                // Всего контента
                let allСontent = this.news.length
                if(allСontent !== index){
                    this.showPopUp(index)
                }
            },
            showPopUp(index){ 
                let number = this.news.findIndex( item =>{
                    return item.id == index
                })

                let obj = new Object();
                this.news.forEach(element => {
                    let id =  element.id
                    obj.id = id
                    this.allId.push(Object.assign({}, obj))
                });
                this.getAllId  = this.allId
                this.allId = []

                this.show = true
                this.text = this.news[number].detail_text
                this.title = this.news[number].title
                this.img = this.news[number].detail_image
                this.id = Number(this.news[number].id)
                let code = this.news[number].code
                // Заблокировать скролл
                this.$emit('noScroll', this.blockScroll)
                this.writeIdArticles(code)
            },
            // Записать id статьи
            writeIdArticles(code){
                this.$router.push({ path: `/${this.langContent}/news/${ code }` })
            },
            getContent(){
                HTTP.get(Routes.news)
                .then( response => {
                    if(response.data.err === 0){
                        // Новости
                        this.news = response.data.news.items
                        this.btnNext = response.data.news.btn_elem_next
                        this.btnPrev = response.data.news.btn_elem_previos
                        // Заголовок
                        this.pagetitle = response.data.news.title
                        this.nextButton = response.data.news.btn_next
                        setTimeout(() => {
                            this.$emit('buttonNextScroll', this.nextButton)
                        }, 0)
                    }
                })
                .catch( error => {
                    console.log(error);
                });
            }
        },
        // watch:{
        //     langContent: function(newValue, oldValue){
        //         this.getContent();
        //     }
        // },
        mounted() {
            this.getContent();
        // axios.get( `https://macchoco.ru/includes/api/getData.php?type_data=news${this.langContent}`)
        //     .then( response => {
        //         if(response.data.err === 0){
        //             // Новости
        //             this.news = response.data.news.items
        //             // Заголовок
        //             this.pagetitle = response.data.news.title
        //             this.nextButton = response.data.news.btn_next
        //             setTimeout(() => {
        //                 this.$emit('buttonNextScroll', this.nextButton)
        //             }, 0)
        //         }
        //     })
        //     .catch( error => {
        //         console.log(error);
        //     });

            // Показать статью по прямой ссылке
            setTimeout(()=>{
                 this.news.forEach(el => {
                    if(el.code === String(this.$route.params.id) ){
                        let index = el.id
                        this.showPopUp(index)
                        return false
                    }
                });
            },200)
        },
        beforeCreate(){
            this.removeScrollButton = true
            this.$emit('removeButtonScrollFooter',this.removeScrollButton)
        }
    }
</script>